<template>
  <h1>Profile</h1>
</template>

<script>
export default {
  name: "ProfilePage",
};
</script>

<style scoped>
</style>